import { SimpleTable } from '@tassat/ag-grid';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getBankOpsDashboardToolbarStats } from 'Selectors/statistics';

import { columnDefs } from './firmOverviewGridOptions';
import { muiStyles } from './styles';
import { FirmOverviewTableProps } from './types';

export const FirmOverviewTable: React.FC<FirmOverviewTableProps> = () => {
    const stats = useAppSelector((state) => getBankOpsDashboardToolbarStats(state, undefined, undefined));
    const classes = muiStyles();

    const data = React.useMemo(() => {
        return [
            {
                type: 'Firms',
                total: stats.firms,
                locked: stats.lockedFirms
            },
            {
                type: 'Accounts',
                total: stats.eoaAccounts,
                locked: stats.lockedEOAAccounts
            },
            {
                type: 'Client Users',
                total: stats.activeClientUsers,
                locked: stats.lockedActiveClientUsers
            },
            {
                type: 'API Users',
                total: stats.apiClientUsers,
                locked: stats.lockedApiClientUsers
            }
        ];
    }, [stats]);

    return (
        <>
            <SimpleTable
                columnDefs={columnDefs}
                // getRowId={({data}) => data.RequestId}
                minHeight={140}
                overlayNoRowsTemplate='No Overview'
                rowData={data}
                title='Overview'
            />
        </>
    );
};